import { CERTIFICATIONS } from '@/clients'
import { djangoErrorHandler } from '@/helpers'
import CONSTANTS from '@/constants'

const postExamAttempt = async userAttemptAndEntityIds => {
  const { voucherId } = userAttemptAndEntityIds
  const route = `vouchers/${voucherId}/attempts`
  return CERTIFICATIONS.post(route, {})
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(djangoErrorHandler(error)))
}

const getExamAttempt = async userAttemptAndEntityIds => {
  const { voucherId, attemptId } = userAttemptAndEntityIds
  const route = `vouchers/${voucherId}/attempts/${attemptId}`
  return CERTIFICATIONS.get(route, {})
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(djangoErrorHandler(error)))
}

const putExamAttempt = async userAttemptAndEntityIds => {
  const { voucherId, attemptId, submission } = userAttemptAndEntityIds
  const route = `vouchers/${voucherId}/attempts/${attemptId}`
  const payload = {
    status: CONSTANTS.CONTENT_USER_STATUS.FINISHED,
    questions: submission,
  }
  return CERTIFICATIONS.put(route, payload)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(djangoErrorHandler(error)))
}

const patchExamAttempt = async userAttemptAndEntityIds => {
  const {
    voucherId,
    attemptId,
    submission,
    status,
    feedback,
  } = userAttemptAndEntityIds
  const route = `vouchers/${voucherId}/attempts/${attemptId}`
  const payload = {
    questions: submission,
  }
  if (status) {
    payload.status = status
  }
  if (feedback) {
    payload.feedback = feedback
  }
  return CERTIFICATIONS.patch(route, payload)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(djangoErrorHandler(error)))
}

const fetchUsersCertifications = async () => {
  try {
    const route = 'certifications/me'
    const {
      data: { results },
    } = await CERTIFICATIONS.get(route)
    return results
  } catch (error) {
    throw djangoErrorHandler(error)
  }
}

const fetchUsersVouchers = async () => {
  try {
    const route = `vouchers/me`
    const {
      data: { results },
    } = await CERTIFICATIONS.get(route)
    return results
  } catch (error) {
    throw djangoErrorHandler(error)
  }
}

const getCertifications = async () => {
  const route = `certifications`
  return CERTIFICATIONS.get(route, {})
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(djangoErrorHandler(error)))
}

const getCertificate = async attemptId => {
  const route = `attempts/${attemptId}/certificate`
  return CERTIFICATIONS.get(route, {})
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(djangoErrorHandler(error)))
}

const postVerifyLab = async attemptId => {
  const route = `attempts/${attemptId}/submit-practice`
  return CERTIFICATIONS.post(route, {})
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(djangoErrorHandler(error)))
}

export {
  postExamAttempt,
  putExamAttempt,
  patchExamAttempt,
  getExamAttempt,
  fetchUsersCertifications,
  fetchUsersVouchers,
  getCertifications,
  getCertificate,
  postVerifyLab,
}
